import { getConsumer } from './consumer';

export function subscribeToPresence(callbacks = {}) {
  const consumer = getConsumer();

  return consumer.subscriptions.create(
    { channel: 'Chat::PresenceChannel' },
    {
      connected() {
        if (callbacks.onConnected) callbacks.onConnected();
      },

      disconnected() {
        if (callbacks.onDisconnected) callbacks.onDisconnected();
      },

      received(data) {
        if (data.type === 'presence' && callbacks.onPresence) {
          callbacks.onPresence(data.user_id, data.online);
        } else if (data.type === 'status' && callbacks.onStatus) {
          callbacks.onStatus(data.user_id, data.chat_status);
        } else if (data.type === 'preference' && callbacks.onPreference) {
          callbacks.onPreference(data.preference);
        }
      }
    }
  );
}